module.exports = __webpack_public_path__ + "static/media/2-1.a6bf0965.mp3";